import {PolymerElement, html} from "@polymer/polymer/polymer-element";
import blockies from "../thirdParty/ethereum-blockies.js";
import {hqx} from "../thirdParty/hqx.js";

class EthereumBlockies extends PolymerElement {

    constructor() {
        super();
    }

    static get template() {
        return html`
            <style>
                #vis canvas {
                    display: block;
                    margin-right: 0px;
                    border-radius: 12.5%;
                    width: 100%;
                    height: 100%;
                }
            </style>
            <div id="vis"></div>
        `;
    }

    static get properties() {
        return {
            seed: {
                type: String,
                value: "",
                notify: true,
                reflectToAttribute: true,
                observer: '_seedChanged',
            },
            size: {
                type: Number,
                value: 8,
                notify: true,
                reflectToAttribute: true,
                observer: '_sizeChanged',
            },
            scale: {
                type: Number,
                value: 4,
                notify: true,
                reflectToAttribute: true,
                observer: '_scaleChanged',
            },
            hqx: {
                type: Array,
                value: [4, 2],
                notify: true,
                reflectToAttribute: true,
                observer: '_hqxChanged',
            },
        };
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    _seedChanged(newValue, oldValue) {
        if (!this.initialized) {
            return;
        }
        this.regenerate();
    }

    _sizeChanged(newValue, oldValue) {
        if (!this.initialized) {
            return;
        }
        this.regenerate();
    }

    _scaleChanged(newValue, oldValue) {
        // console.log("_scaleChanged", newValue, oldValue)
        if (!this.initialized) {
            return;
        }
        this.regenerate();
    }

    _hqxChanged(newValue, oldValue) {
        // console.log("_hqxChanged", newValue, oldValue)
        if (!this.initialized) {
            return;
        }
        this.regenerate();
    }

    ready() {
        super.ready();

        this.regenerate();

        this.initialized = true;
    }

    valuesChanged() {
        const currentValues = "seed=" + this.seed
            + "&size=" + this.size
            + "&scale=" + this.scale
            + "&hqx=" + this.hqx
        ;
        const updated = currentValues !== this.previousValues;
        this.previousValues = currentValues;
        return updated;
    }

    regenerate() {
        if (!this.valuesChanged()) {
            return;
        }
        if (this.iconCanvas) {
            this.iconCanvas.remove();
        }
        if (!this.seed) {
            return;
        }
        const options = {
            seed: this.seed.substr(2),
            // color: '#dfe',
            // bgcolor: '#aaa',
            size: this.size || 8,
            scale: this.scale || 1,
            // spotcolor: '#000',
        };
        const blocky = blockies.create(options);
        this.iconCanvas = (this.hqx || []).reduce((b, hqxAmmount) => hqx(b, hqxAmmount), blocky);
        this.$.vis.append(this.iconCanvas);
    }
}

customElements.define('ethereum-blockies', EthereumBlockies);
